// extracted by mini-css-extract-plugin
module.exports = {"container":"t_c","accordion":"t_0","accordion__item":"t_1","accordion__head":"t_2","accordion__body":"t_3","accordion__item____selected":"t_4"};